import { get } from 'lodash';

const root = (state: object) => get(state, 'disclaimerModalState');

export const getOpen = (state: object) => get(root(state), 'open', false);
export const showCloseButton = (state: object) => get(root(state), 'showCloseButton', false);
